import { type useRowRelationsState } from '~/store/rowRelations/rowRelations.selectors';
import type { RowRelationSpreadsheetStatus } from '~/store/rowRelations/rowRelations.types';

export const aggregateSpreadsheetRowRelationsStatuses = (state: ReturnType<typeof useRowRelationsState>): RowRelationSpreadsheetStatus => {
  const initialStatus: Mutable<RowRelationSpreadsheetStatus> = {
    required: false,
    processing: false,
    failed: false,
  };
  return Object.values(state).reduce((aggregate: Mutable<RowRelationSpreadsheetStatus>, spreadsheetState) => {
    aggregate.required = aggregate.required || spreadsheetState.required;
    aggregate.processing = aggregate.processing || spreadsheetState.processing;
    aggregate.failed = aggregate.failed || spreadsheetState.failed;

    return aggregate;
  }, initialStatus);
};
